import React, { useState, useEffect } from "react";
import styles from "./genai.module.scss";
import starLoader from "img/genai/StarLoader.svg";
export const GenaiLoader = (props) => {
  const [position, setPosition] = useState(0);
  const [isloading, setIsloading] = useState(false);

  const loadingSteps = [
    { text: "Model analysing the elements..." },
    { text: "Putting together all the elements for the module..." },
    { text: "Fetching relevant metadata..." },
    { text: "Fetching images for all the modules..." },
  ];

  useEffect(() => {
    setIsloading(props.isloading || false);
  }, [props.isloading]);

  useEffect(() => {
    if (!isloading) return;

    const interval = setInterval(() => {
      setPosition((prev) => (prev + 1) % loadingSteps.length);
    }, 1000);

    return () => clearInterval(interval);
  }, [isloading]);

  const currentStep = position % loadingSteps.length;

  if (!isloading) return null;

  return (
    <div className={styles.container}>
      <div className={styles.progressbox}>
        <div className={styles.progressIndicator}>
          <div className={styles.circularProgress}>
            <svg viewBox="0 0 36 36">
              <circle
                className={styles.progressBg}
                cx="18"
                cy="18"
                r="15.9155"
                strokeWidth="2"
              />
              <path
                className={styles.progressSegment}
                d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
                strokeDasharray="25,90"
                transform={`rotate(${position * 90} 18 18)`}
              />
            </svg>
          </div>
          <div className={styles.loadingText}>
            <span>{loadingSteps[currentStep].text}</span>
          </div>
        </div>
      </div>

      <div className={styles.skeletonLoader}>
        <span >
          <img src={starLoader} alt="loader" className={styles.strloader} />
        </span>
        <div className={styles.skeletonDropdownGrid}>
          {[...Array(13)].map((_, i) => (
            <div
              className={`${styles.skeletonDropdown} ${styles.shimmer}`}
              key={i}
            />
          ))}
        </div>
        <div className={`${styles.skeletonContainer} ${styles.shimmer}`} />
        {/* <div className={`${styles.skeletonContainer} ${styles.shimmer}`} /> */}
        <div className={styles.skeletonSplitRow}>
          <div
            className={`${styles.skeletonContainer} ${styles.shimmer} ${styles.twenty}`}
          />
          <div
            className={`${styles.skeletonContainer} ${styles.shimmer} ${styles.eighty}`}
          />
        </div>
      </div>
    </div>
  );
};
